import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import {
  EnrollMarketingFlowContactPayload,
  MarketingFlowEnrollment
} from "../../marketing.types";

export const requestEnrollMarketingFlowContact = async ({
  flowId,
  contactId
}: EnrollMarketingFlowContactPayload): Promise<MarketingFlowEnrollment> => {
  return await instance.post(`${ApiRoutesMarketing.Flows}/${flowId}/enroll`, {
    contactId
  });
};
